import React from 'react';
import VerticalStack from '../components/VerticalStack';

import RoomPicker from '../components/RoomPicker';
import Section from '../components/Section';

import Header from '../components/Header';
import { Slideshow } from '../components/slideshow/Slideshow';
import { NotFound } from '../App';
import withHelmet from '../utils/withHelmet';
import BookingForm from '../components/booking/BookingForm';

const RoomPage = ({ id, content }) => {
  const room = content.room(id);
  if (!room) {
    return <NotFound />;
  }

  return (
    <VerticalStack>
      <div style={{ height: '100vh', width: '100vw' }}>
        <Slideshow images={room.gallery} AbovePagination={BookingForm}>
          <Header
            title={room.title}
            subtitle={room.subtitle}
            style={{ zIndex: 20, position: 'absolute', top: 0, left: 0 }}
          />
        </Slideshow>
      </div>
      <Section background={room.gallery[2]}>
        <RoomPicker rooms={content.rooms} content={content} />
      </Section>
    </VerticalStack>
  );
};

export default withHelmet('room')(RoomPage);
